import { useEffect } from "react";
import { Form, Modal, Checkbox } from "antd";
import { crmService } from "../../../../services/crm.service";

function ModalForm(props) {
  const { open, onOk, onCancel, companyId } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      crmService.getCompanyById(companyId).then((res) => {
        form.setFieldsValue(res);
      });
    }
  }, [open, companyId, form]);

  return (
    <>
      <Modal
        title="Modifca il Consenso"
        open={open}
        onOk={() => form.submit()}
        onCancel={onCancel}
        cancelText={"Cancella"}
      >
        <Form
          form={form}
          name="basic"
          onFinish={(e) => onOk(e)}
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          autoComplete="off"
        >
          <Form.Item name="id"></Form.Item>
          <Form.Item
            name="consentPrivacy"
            valuePropName="checked"
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Checkbox
              onChange={(value) => {
                let checked = value.target.checked;
                form.setFieldValue("consentPrivacy", checked);
              }}
            >
              Consenso Privacy
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="consentMailingList"
            valuePropName="checked"
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Checkbox
              onChange={(value) => {
                let checked = value.target.checked;
                form.setFieldValue("consentMailingList", checked);
              }}
            >
              Consenso Mailing List
            </Checkbox>
          </Form.Item>
          <Form.Item
            name="consentCall"
            valuePropName="checked"
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Checkbox
              onChange={(value) => {
                let checked = value.target.checked;
                form.setFieldValue("consentCall", checked);
              }}
            >
              Consenso Call
            </Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
export default ModalForm;
